import React, { Component } from 'react'
import Modal from 'react-modal'
import { connect } from 'react-redux'
import { Glyphicon, Grid, Row, Col, ListGroup, ListGroupItem } from 'react-bootstrap'
import { stringMatchInsensitive, getSubModalStyles } from '../../common/utils'
import QTextInputField from './QTextInputField'
import op from 'object-path'

const styles = {
    content: {
        top: '20%',
        left: '35%',
        bottom: '20%',
        right: '35%'
    }
}

class ChooseLockCompanyModal extends Component {
    constructor(props) {
        super(props)
    }

    state = {
        search: '',
        selectedCompany: null
    }

    updateSearch = (e) => {
        const { allCompanies } = this.props
        const searchString = e.target.value

        if (!searchString || !searchString.length) {
            return this.setState({ searchResults: null }, () => console.log(this.state))
        }

        const searchResults = []

        for (const company of allCompanies) {
            if (company && stringMatchInsensitive(company.name, searchString)) {
                searchResults.push(company)
            }
        }

        this.setState({ searchResults })
    }

    toggleUserSelection = (company) => {
        const newState = { ...this.state }

        if (newState.selectedCompany && newState.selectedCompany._id === company._id) {
            newState.selectedCompany = null
        } else {
            newState.selectedCompany = company
        }

        this.setState(newState)
    }

    saveAndExit = () => {
        this.props.sendResults(this.state.selectedCompany)
    }


    render() {
        const browsedResult = this.state.searchResults ? this.state.searchResults : this.props.allCompanies

        const sortedResult = browsedResult.sort((a, b) => {
            const aCompany = op.get(a, 'company.name')
            const bCompany = op.get(b, 'company.name')

            if (aCompany < bCompany) { return -1 } else { return 1 }
        })

        return (
            <div>
                <Modal
                    ariaHideApp={false}
                    isOpen={this.props.modalIsOpen}
                    onAfterClose={() => this.setState({ selectedCompany: null })}
                    onRequestClose={() => this.props.closeModal()}
                    style={getSubModalStyles()}>

                    <div className="qCloseButton" onClick={() => this.props.closeModal()}>Stäng</div>

                    <br />
                    <br />

                    <Grid fluid>
                        <Row>
                            <Col xs={12} lg={12}>
                                <QTextInputField onChange={this.updateSearch} />
                            </Col>
                        </Row>
                        <br />
                        <Row>
                            <Col lg={12} xs={12}>
                                <ListGroup>
                                    {!sortedResult.length ? '-' : null}

                                    {sortedResult.map(company => {

                                        const isToggled = this.state.selectedCompany ? this.state.selectedCompany._id === company._id : false

                                        return (
                                            <ListGroupItem key={company._id} onClick={() => this.toggleUserSelection(company, isToggled)}>
                                                <Glyphicon id={company._id} glyph={`glyphicon glyphicon-${isToggled ? 'check' : 'unchecked'}`} style={{ color: 'grey', fontSize: 18, marginRight: 10 }} />
                                                <span>{company.name}</span>
                                            </ListGroupItem>
                                        )
                                    })}
                                </ListGroup>
                            </Col>
                        </Row>
                        <br />
                        <Row>
                            <Col lg={12} xs={12}>
                                <div className="qSaveButton" onClick={this.saveAndExit}>Spara {this.state.selectedCompany ? this.state.selectedCompany.name : null}</div>
                            </Col>
                        </Row>
                    </Grid>

                </Modal>
            </div>
        )
    }
}

const mapState = (state, ownProps) => {
    const allCompanies = ownProps.lock.users.reduce((acc, user) => {
        const company = state.collectionData.keyedCompanies[user.company]
        if (!company) return acc

        if (!acc.find(a => a._id === company._id)) acc.push(company)

        return acc
    }, [])

    return {
        allCompanies
    }
}

const mapDispatch = (dispatch) => {
    return {}
}

export default connect(mapState, mapDispatch)(ChooseLockCompanyModal)